import { useInfiniteQuery } from '@tanstack/react-query';
import { likeGoodsService } from 'shared/src/api';
import type { GetLikedGoodsRequest } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

/**
 * 찜한 상품 리스트 (cursor: `last_sno`).
 * iOS `LikedProductFeature.products` 와 동일 페이지네이션.
 */
export const useLikedGoods = (
  params: Omit<GetLikedGoodsRequest, 'last_sno'>,
) => {
  return useInfiniteQuery({
    queryKey: queryKey.likedGoods(params),
    queryFn: ({ pageParam }) =>
      likeGoodsService.getLikedGoods({
        ...params,
        last_sno: pageParam,
      }),
    initialPageParam: undefined as number | undefined,
    getNextPageParam: lastPage => {
      const lastItem = lastPage.item_list[lastPage.item_list.length - 1];
      return lastItem ? lastItem.item.sno : undefined;
    },
    select: data => ({
      total_count: data.pages[0]?.total_count ?? 0,
      primary_card_list: data.pages[0]?.primary_card_list ?? null,
      item_list: data.pages.flatMap(page => page.item_list),
    }),
  });
};
